import styled from 'styled-components';

export const Wrap = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
`;

export const TrustedSiteTitle = styled.div`
  font-family: YoonGothicPro, '맑은 고딕', Gulim, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: #274ab3;
  padding-left: 12px;
  padding-top: 8px;
  padding-bottom: 4px;
  background-color: #fff;
`;

export const NoneContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f1f2f4;
  height: calc(100vh - 186px);
  img {
    width: 60px;
    margin-bottom: 15px;
  }
  span {
    font-size: 14px;
    color: #666;
  }
`;

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background-color: #fff;
  gap: 4px;
`;
